﻿var mmsystem = mmsystem || {};
mmsystem.payments = mmsystem.payments || {};
mmsystem.payments.stripe = mmsystem.payments.stripe || {};

var events = require('events');

mmsystem.payments.stripe.ajax = {

    Language: "En",
    LanguageUrlPrefix: "En",
    UseGlobalization: false,
    EventEmitter: new events.EventEmitter(),

    Init: function (lang, useGlobalization) {
        this.Language = typeof lang !== "undefined" ? lang : this.Language;
        this.UseGlobalization = typeof useGlobalization !== "undefined" ? useGlobalization : this.UseGlobalization;
        this.LanguageUrlPrefix = this.UseGlobalization ? "/" + lang : "";
    },

    MakePayment: function (data) {
        //console.log("MissionSystem.CustomScripts.Core.Ajax.Payments.Stripe.MakePayment...");
        $.ajax({
            url: mmsystem.payments.stripe.ajax.LanguageUrlPrefix + "/Orders/APIStripePayment",
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                //$(MissionSystem.CustomScripts.Core.Ajax).trigger("serverError", result);
                mmsystem.payments.stripe.ajax.EventEmitter.emit('serverError', result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Add MissionSystem.CustomScripts.Core.Ajax.Payments.Stripe "paymentStripeComplete" Event');
                //console.log(result);
                // result = SimpleObjectResult { Type = ResultType.Success, Message = $"Order  saved", Object = new { Order = DBOrder.GetSerializableObject() } } success - 1, error - 2
                //$(MissionSystem.CustomScripts.Core.Ajax.Payments.Stripe).trigger("paymentStripeComplete", result);
                mmsystem.payments.stripe.ajax.EventEmitter.emit('paymentStripeComplete', result);
            }
        });
    }

};


//Node exports
module.exports = mmsystem.payments.stripe.ajax;

// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}